import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export function ConfirmDelete({ open, handleClose: handleCancel, handleDelete, label }) {
  return (
    <>
      <Dialog open={open}>
        <DialogTitle>Delete {label}</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete {label}?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button variant="contained" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
